import SearchInput from 'components/molecules/search-input'
import * as ROUTES from 'config/routes'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'

const Container = styled.div``

function Searchbox({ className, history, onSubmit }) {
  const [searchQuery, setSearchQuery] = useState('')

  const handleSetSearchQuery = (query) => {
    setSearchQuery(query)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    onSubmit()
    history.push(`${ROUTES.SEARCH_RESULTS}?q=${searchQuery}`)
  }

  return (
    <Container className={className}>
      <SearchInput
        onChange={handleSetSearchQuery}
        onSubmit={handleSubmit}
        value={searchQuery}
      />
    </Container>
  )
}

Searchbox.propTypes = {
  className: PropTypes.string,
  history: PropTypes.object.isRequired,
  onSubmit: PropTypes.func,
}

Searchbox.defaultProps = {
  onSubmit: () => {},
  className: '',
}

export default withRouter(Searchbox)
